/* Arbove — reprend la main sur le sticky header de VOYA.

   theme.js:1543 installe `window.onscroll = debounce(fn, 100)`, un debounce
   trailing-only : la classe .active bascule 100 ms APRES l'arret du scroll,
   puis 300 ms de transition CSS s'enchainent. En bas de page, le rebond iOS
   fait osciller pageYOffset autour du seuil de 30 px -> bascules repetees et
   tardives = clignotement. Le setTimeout(…, 0) interne ajoute encore une frame
   de retard, et `window.onscroll =` (au lieu de addEventListener) n'est pas
   passive, donc il bloque le thread de scroll.

   Ici : rAF + hysteresis, listener passif, aucune ecriture si l'etat n'a pas
   change. Le <header> porte lui-meme la classe `section-<id>` ciblee par
   theme.js, c'est donc lui qu'on bascule. */
(function () {
  if (window.__arbHeaderScroll) return;
  window.__arbHeaderScroll = true;

  var ON = 40; // .active au-dela de 40 px
  var OFF = 12; // retiree en dessous de 12 px — entre les deux : zone morte

  var header = null;
  var active = false;
  var ticking = false;

  function apply() {
    ticking = false;
    if (!header) return;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (y < 0) y = 0; // rebond iOS : pageYOffset peut passer sous zero
    if (!active && y > ON) {
      active = true;
      header.classList.add('active');
    } else if (active && y < OFF) {
      active = false;
      header.classList.remove('active');
    }
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(apply);
    }
  }

  function adopt() {
    var el = document.querySelector('header.site-header');
    if (!el || el.getAttribute('data-sticky') !== 'sticky') return false;
    window.onscroll = null; // neutralise le handler debounce de theme.js
    header = el;
    active = el.classList.contains('active');
    apply();
    return true;
  }

  function start() {
    if (!adopt()) return;
    window.addEventListener('scroll', onScroll, { passive: true });
    // L'editeur de theme remplace le <header> et re-assigne window.onscroll.
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector('header.site-header')) adopt();
    });
  }

  // theme.js est charge en defer et s'initialise au ready : on passe apres.
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start);
})();
